/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
/**
 * 
 * @export
 * @interface RunReferenceMeasurementRequestDto
 */
export interface RunReferenceMeasurementRequestDto {
    /**
     * 
     * @type {string}
     * @memberof RunReferenceMeasurementRequestDto
     */
    parameterCombinationHash?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RunReferenceMeasurementRequestDto
     */
    combinationSetId?: string;
    /**
     * 
     * @type {string}
     * @memberof RunReferenceMeasurementRequestDto
     */
    $type?: RunReferenceMeasurementRequestDtoTypeEnum;
}


/**
 * @export
 */
export const RunReferenceMeasurementRequestDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedJobExecutionDtoRunReferenceMeasurementRequestDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.JobExecution.Dto.RunReferenceMeasurementRequestDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type RunReferenceMeasurementRequestDtoTypeEnum = typeof RunReferenceMeasurementRequestDtoTypeEnum[keyof typeof RunReferenceMeasurementRequestDtoTypeEnum];


/**
 * Check if a given object implements the RunReferenceMeasurementRequestDto interface.
 */
export function instanceOfRunReferenceMeasurementRequestDto(value?: unknown): value is RunReferenceMeasurementRequestDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(RunReferenceMeasurementRequestDtoTypeEnum)[0];
}

export function RunReferenceMeasurementRequestDtoFromJSON(json: any): RunReferenceMeasurementRequestDto {
    return RunReferenceMeasurementRequestDtoFromJSONTyped(json, false);
}

export function RunReferenceMeasurementRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): RunReferenceMeasurementRequestDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'parameterCombinationHash': !exists(json, 'parameterCombinationHash') ? undefined : json['parameterCombinationHash'],
        'combinationSetId': !exists(json, 'combinationSetId') ? undefined : json['combinationSetId'],
        '$type': !exists(json, '$type') ? undefined : json['$type'],
    };
}

export function RunReferenceMeasurementRequestDtoToJSON(value?: RunReferenceMeasurementRequestDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'parameterCombinationHash': value.parameterCombinationHash,
        'combinationSetId': value.combinationSetId,
        '$type': value.$type,
    });
}

